import React from "react";
import Header from "./Header";
import Home from "./Home";
import "../styles/account.css";
import { useAuth } from "../context/AuthContext";
import { useHistory } from "react-router-dom";

function Account() {
  const { currentUser, logout } = useAuth();
  const history = useHistory();

  const handleLogout = (e) => {
    e.preventDefault();
    logout();
  };

  const handleResetPassword = (e) => {
    e.preventDefault();
    if (currentUser) {
      history.push("/resetPassword");
    } else {
      logout();
    }
  };

  return (
    <div>
      <Header />
      <Home />
      <div className="account">
        <div className="account__container">
          <h1>HESABIM</h1>
          <div className="accInfo">
            <p>
              <span>KULLANICI ADI:</span> {currentUser && currentUser.username}
            </p>
            <p>
              <span>E-POSTA:</span> {currentUser && currentUser.email}
            </p>
          </div>
          <div className="button accountButton">
            <button type="submit" onClick={handleResetPassword}>
              SIFREMI SIFIRLA
            </button>
            <button type="submit" onClick={handleLogout}>
              CIKIS YAP
            </button>
          </div>
          <div className="topLeftBorder">
            <div>
              <div className="borderTop"></div>
              <div className="borderLeft"></div>
            </div>
          </div>
          <div className="bottomRigtBorder">
            <div>
              <div className="borderRight"></div>
              <div className="borderBottom"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Account;
